import React from 'react';
import { Info } from 'lucide-react';

export function SettingsRow({ title, description, children }) {
  return (
    <div className="flex items-start justify-between gap-6 py-3.5">
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1.5">
          <span className="text-[14px] font-semibold text-[#1A1533]">{title}</span>
          <Info size={12} className="text-[#A39DB8]" />
        </div>
        {description && <p className="text-[12.5px] text-[#4A4463] mt-1 leading-relaxed">{description}</p>}
      </div>
      <div className="shrink-0 pt-1">{children}</div>
    </div>
  );
}

export function RadioGroup({ value, onChange, options }) {
  return (
    <div className="flex items-center gap-5 flex-wrap">
      {options.map((o) => (
        <label key={o.value} className="inline-flex items-center gap-2 cursor-pointer">
          <span className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${value === o.value ? 'border-[#5B4FE8]' : 'border-[#C4BEDA]'}`}>
            {value === o.value && <span className="w-2 h-2 rounded-full bg-[#5B4FE8]" />}
          </span>
          <input type="radio" checked={value === o.value} onChange={() => onChange(o.value)} className="sr-only" />
          <span className="text-[13px] text-[#1A1533]">{o.label}</span>
        </label>
      ))}
    </div>
  );
}
